import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=87d9808e&scoped=true"
import script from "./AvatarGroup.vue?vue&type=script&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=87d9808e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d9808e",
  null
  
)

export default component.exports